module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home-module"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "module-selling"
  }, [_c('div', [_c('router-link', {
    attrs: {
      "to": _vm.adUp.to,
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "alt": _vm.adUp.aname,
      "src": _vm.adUp.atturl,
      "height": "372px",
      "width": "1190px"
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "ad",
    staticStyle: {
      "height": "348px"
    }
  }, [(_vm.adLeft) ? _c('router-link', {
    attrs: {
      "to": _vm.adLeft.to,
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "alt": _vm.adLeft.aname,
      "src": _vm.adLeft.atturl,
      "width": "294px",
      "height": "348px"
    }
  })]) : _vm._e()], 1), _vm._v(" "), _c('ul', _vm._l((_vm.adRightList), function(item, index) {
    return (index < 10) ? _c('li', {
      key: item.key,
      staticClass: "double"
    }, [_c('router-link', {
      attrs: {
        "to": item.to,
        "title": item.aname,
        "target": "_blank"
      }
    }, [_c('img', {
      attrs: {
        "alt": item.aname,
        "src": item.atturl,
        "height": "170px",
        "width": "170px"
      }
    })])], 1) : _vm._e()
  }), 0)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "module-title"
  }, [_c('span', [_vm._v("自营品牌")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d97e29c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/home-page/self-support/index.vue
// module id = 1562
// module chunks = 1